<template>
  <div
    class="modal fade"
    id="uploadProgressModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            <b>{{ lang.UPM000 }}...</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="progress">
            <div
              class="progress-bar progress-bar-msm"
              :style="`width: ${progress}%`"
            ></div>
          </div>
          {{ progress }} %
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised btn-danger"
            @click="$emit('cancelUpload')"
          >
            {{ lang.UPM001 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UploadProgressModal",
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lang: {
        UPM000: "Uploading",
        UPM001: "Cancel",
      },
    };
  },
  watch: {
    showDialog(newValue) {
      if (newValue) {
        this.openUploadProgressModal();
      } else {
        this.closeUploadProgressModal();
      }
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
  },
  methods: {
    openUploadProgressModal() {
      $("#uploadProgressModal").modal("show");
    },
    closeUploadProgressModal() {
      $("#uploadProgressModal").modal("hide");
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  width: 400px;
  margin: 40vh auto;
}

.progress {
  width: 100%;
  height: 0.3em;
}

.progress-bar-msm {
  margin: 0;
  background: var(--color-primary-input);
}
</style>



// WEBPACK FOOTER //
// UploadProgressModal.vue?25a9df03